<template>
	<Col class="intro-wrapper overflow-y-auto overflow-x-hidden pa-16">
		<Row>
			<Col class="flex-1 flex-centerize">
				<h1 class="text-align-left width-100">Take action <br />in a new way</h1>
				<p class="subtitle mt-5">
					Notifications let you handle and respond to events in a structured way. You can receive them in the browser, in an email, or in
					Slack. Collaborate on notifications using shared inboxes.
				</p>
			</Col>
			<Col class="img-container flex-1 flex-centerize">
				<img class="intro-img" :src="introImgSrc" draggable="false" />
			</Col>
		</Row>
		<Col class="col-img-container flex-1 flex-centerize">
			<img class="intro-img" :src="introImgSrc" draggable="false" />
		</Col>
		<div>
			<div class="examples mb-5">
				<p class="font-weight-600 mb-2">Receive an actionable notification:</p>
				<ul class="ma-0 pa-0">
					<li>
						<Row class="flex-align-center">
							<Row class="icons">
								<IntegrationIcon integrationName="pipedrive" :size="integrationIconSize" />
								<IntegrationIcon integrationName="calendly" :size="integrationIconSize" />
								<IntegrationIcon integrationName="ply-webhooks" :size="integrationIconSize" />
							</Row>

							<p>When an event in your apps or a webhook is triggered</p>
						</Row>
					</li>
					<li>
						<Row class="flex-align-center">
							<Row class="icons">
								<IntegrationIcon integrationName="google-forms" :size="integrationIconSize" />
								<IntegrationIcon integrationName="typeform" :size="integrationIconSize" />
							</Row>
							<p>When a form is submitted</p>
						</Row>
					</li>

					<li>
						<Row align-content="right">
							<Row class="icons">
								<IntegrationIcon integrationName="ply-scheduled-webhooks" :size="integrationIconSize" />
							</Row>
							<p>On a predefined schedule</p>
						</Row>
					</li>
				</ul>
			</div>

			<AnemicButton @click="showWizard" class="new-button" id="btn">Create a notification</AnemicButton>

			<p class="font-weight-600 mt-12 mb-2">Watch tutorial</p>

			<Col class="iframe-container">
				<iframe
					src="https://www.loom.com/embed/63680f35fb1448c5a3cfa0c5602c70ec?sid=887a0f6f-017c-4fe9-a6e2-7e07dd9e2fbc"
					frameborder="0"
					webkitallowfullscreen
					mozallowfullscreen
					allowfullscreen
				/>
			</Col>
		</div>
	</Col>
</template>
<script>
import AppDialogManagerService from '@/components/dialogs/AppDialogManager/app-dialog-manager-service';
import { FeatureType } from '@/components/CreationWizard/Steps/ChooseProjectAndFeatureType/FeatureTypeSelector/feature-type-selector.const';

import introImgSrc from '@/assets/img/notifications-intro.png';

const VIDEO_URL = 'https://www.loom.com/embed/63680f35fb1448c5a3cfa0c5602c70ec';

export default {
	name: 'NotificationsIntro',
	components: {},

	methods: {
		showWizard() {
			AppDialogManagerService.openCreationWizardDialog({
				initialState: { featureTypeId: FeatureType.InternalNotification },
			});
		},
		openVideoDialog() {
			AppDialogManagerService.openIFrameDialog({ iframeUrl: VIDEO_URL });
		},
	},
	data() {
		return {
			introImgSrc,
			integrationIconSize: 22,
		};
	},
};
</script>
<style scoped lang="scss">
h1 {
	color: #262626;
	font-size: 48px;
	line-height: 1;
	font-weight: 800;
}
p,
li {
	line-height: 1.5;
}
p {
	margin: 10px 0;
	font-size: 16px;
}
li p {
	font-size: 14px;
}

.intro-img {
	width: 100%;
	height: auto;
	max-width: 553px;
}
#btn {
	padding: 0px 25px !important;
	height: 45px !important;
	border-radius: 8px !important;
	background-color: #6762f0 !important;
	text-transform: none !important;
	color: var(--bg-color);
	font-size: 14px !important;
	font-weight: normal !important;
	width: auto;
	display: inline-block;
}
.watch-video-link {
	font-size: 18px;
}
li {
	list-style: none;
	margin: 10px 0;

	.integration-icon + .integration-icon {
		margin-left: -4px;
	}
	p {
		margin: 0 0 0 10px;
	}
}
.iframe-container {
	iframe {
		border-radius: 14px;
		max-width: 100%;
		width: 430px;
		height: 244px;
	}
}
.icons {
	min-width: 55px;
}

.intro-wrapper[min-width~='850px'] {
	.img-container {
		display: flex;
	}
	.col-img-container {
		display: none;
	}
}
.intro-wrapper[max-width~='849px'] {
	.col-img-container {
		display: flex;
	}
	.img-container {
		display: none;
	}
}
</style>
